export default __webpack_public_path__ + "static/media/two-lines-green-blue-pattern.5fcf241e.svg";